<template lang="pug">
#filtros.mb-3.mt-2
    .filtrar-laudo-container
        .filtrar-laudo-input-container
            .filtrar-laudo__input
                i.el-icon-search

                input.pesquisa-inteligente__input(
                    v-model='filtros.filtro',
                    type='text',
                    :placeholder='placeholders',
                    autocomplete='off',
                    :trigger-on-focus='false',
                    @input='tratarPesquisaInteligente(filtros.filtro)',
                    @keyup.enter='aplicar',
                    @blur='fecharLista'
                )

        .filtrar-laudo__button
            el-popover(
                placement='bottom-start',
                width='750',
                trigger='click',
                :popper-class='popoverClass'
            )
                BaseButton.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}

                el-form.filtro(label-position='top')
                    .filtrar-laudo-popover-header
                        .filtrar-laudo-popover-header__text(slot='title')
                            | {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}
                        .filtrar-laudo-popover-header__link(@click='aplicar')
                            | {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

                    .filtrar-laudo-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion
                            )
                                el-collapse-item(
                                    v-if='perfilAnalista && mostrarEmpresa',
                                    :title='$t("mensagens.laudos.empresa")',
                                    name='empresa'
                                )
                                    .el-collapse-empresa--loading
                                        el-select(
                                            v-model='empresasSelecionadas',
                                            filterable,
                                            remote,
                                            multiple,
                                            reserve-keyword,
                                            :remote-method='remoteMethodEmpresa',
                                            value-key='id',
                                            style='width: 98%'
                                        )
                                            el-option(
                                                v-for='empresa in listaEmpresas',
                                                :key='`${empresa.name}${empresa.id}`',
                                                :label='empresa.name',
                                                :value='empresa'
                                            )
                                                | {{ empresa.name }}

                                el-collapse-item(
                                    :title='$t("mensagens.laudos.situacao")',
                                    name='situacao'
                                )
                                    .el-collapse-item__situacao--loading(
                                        v-loading='!situacoesPossiveis.length'
                                    )
                                        el-checkbox-group.checkbox-group(
                                            v-model='situacoesSelecionadas'
                                        )
                                            el-checkbox(
                                                v-for='(situacao, index) in situacoesPossiveis',
                                                :label='situacao',
                                                :key='index'
                                            )
                                                | {{ traduzirSituacao(situacao.nome) }}

                                el-collapse-item(
                                    :title='$t("mensagens.laudos.dataSolicitacao")',
                                    name='dataSolicitacao'
                                )
                                    .el-collapse-item__date--loading
                                        .date
                                            el-date-picker(
                                                v-model='filtros.dataCadastroInicio',
                                                type='date',
                                                :placeholder='$t("mensagens.comuns.selecione")',
                                                style='width: 47%',
                                                format='dd/MM/yyyy'
                                            )
                                            span(
                                                style='padding-left: 16px; padding-right: 16px; font-size: 14px'
                                            ) à
                                            el-date-picker(
                                                v-model='filtros.dataCadastroFim',
                                                type='date',
                                                :placeholder='$t("mensagens.comuns.selecione")',
                                                style='width: 47%',
                                                format='dd/MM/yyyy'
                                            )

                                el-collapse-item(
                                    :title='$t("mensagens.laudos.dataEntrega")',
                                    name='dataEntrega'
                                )
                                    .el-collapse-item__date--loading
                                        .date
                                            el-date-picker(
                                                v-model='filtros.dataFinalizacaoInicio',
                                                type='date',
                                                :placeholder='$t("mensagens.comuns.selecione")',
                                                style='width: 47%',
                                                format='dd/MM/yyyy'
                                            )
                                            span(
                                                style='padding-left: 16px; padding-right: 16px; font-size: 14px'
                                            ) à
                                            el-date-picker(
                                                v-model='filtros.dataFinalizacaoFim',
                                                type='date',
                                                :placeholder='$t("mensagens.comuns.selecione")',
                                                style='width: 47%',
                                                format='dd/MM/yyyy'
                                            )

                                el-collapse-item(
                                    v-if='mostrarStatus',
                                    :title='$t("mensagens.laudos.statusAlerta")',
                                    name='status'
                                )
                                    el-select.custom-collapse(
                                        v-model='statusSelecionado',
                                        :placeholder='$t("mensagens.comuns.selecione")',
                                        value-key='id'
                                    )
                                        el-option(
                                            v-for='status in statusPossiveis',
                                            :key='status.codigo',
                                            :label='status.nome',
                                            :value='status'
                                        )
                                            | {{ traduzirSituacao(status.nome) }}

                                el-collapse-item(v-if='mostrarRenovabio', :title="$t('mensagens.laudos.renovabioNome')", name='renovabio')
                                    .checkbox-group
                                        el-radio(
                                            v-model='filtros.elegivelRenovabio',
                                            :label='true'
                                        ) {{ $t('mensagens.laudos.elegivel') }}
                                        el-radio(
                                            v-model='filtros.elegivelRenovabio',
                                            :label='false'
                                        ) {{ $t('mensagens.laudos.inelegivel') }}

                                el-collapse-item(
                                    v-if='mostrarRenovabio',
                                    :title='$t("mensagens.laudos.anoCertificacao")',
                                    name='anoRenovabio'
                                )
                                    el-select.custom-collapse(
                                        v-model='filtros.anoRenovabio',
                                        :placeholder='$t("mensagens.comuns.selecione")',
                                        value-key='id'
                                    )
                                        el-option(
                                            v-for='ano in anos',
                                            :key='ano',
                                            :label='ano',
                                            :value='ano'
                                        )
                                            | {{ ano }}

    .filtrar-laudo-filtro-selecionado
        span.filtrar-laudo-filtro-selecionado__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}
        el-tag.filtrar-laudo-filtro-selecionado__tag(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ getNome(tag.nome, tag.valor) }}

        el-tag.filtrar-laudo-filtro-selecionado__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.blocoFiltros.uteis.limparFiltro') }}
            i.el-icon-delete

        span.filtrar-laudo-filtro-selecionado__nenhum(v-else) {{ $t('mensagens.blocoFiltros.uteis.nenhumFiltroSelecionado') }}
</template>

<script>
import LaudosService from '@/services/LaudosService';
import TipoLaudo from '@/constants/TipoLaudo';
import UsuarioService from '@/services/UsuarioService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { mapState } from 'vuex';

export default {
    name: 'FiltrosUnificados',

    components: {
        BaseButton
    },

    emits: ['getFiltros'],
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            empresasSelecionadas: [],
            situacoesSelecionadas: [],
            collapseFiltroAvancado: [''],
            tags: [],
            listaEmpresas: [],
            situacoesPossiveis: [],
            statusPossiveis: [],
            anos: [],
            perfilAnalista: null,
            statusSelecionado: '',
            filtros: {
                territoriosIds: '',
                empresasIds: '',
                situacaoIds: [],
                dataCadastroInicio: '',
                dataCadastroFim: '',
                dataFinalizacaoInicio: '',
                dataFinalizacaoFim: '',
                filtro: '',
                tipoLaudoId: this.tipoLaudo,
                statusId: '',
                elegivelRenovabio: '',
                anoRenovabio: null
            }
        };
    },
    computed: {
        ...mapState(['usuarioLogado']),
        popoverClass() {
            return `el-popover-laudo-id-${this.tipoLaudo}`;
        },
        mostrarEmpresa() {
            const tiposPermitidos = [
                TipoLaudo.AGRICOLA,
                TipoLaudo.BACEN_FISCALIZACAO,
                TipoLaudo.TECNICO_AGRICOLA
            ];

            return tiposPermitidos.includes(this.tipoLaudo);
        },
        mostrarStatus() {
            const tiposPermitidos = [
                TipoLaudo.BACEN_FISCALIZACAO,
                TipoLaudo.BACEN_140,
                TipoLaudo.BENFEITORIAS,
                TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO
            ];

            return tiposPermitidos.includes(this.tipoLaudo);
        },
        mostrarRenovabio() {
            return this.tipoLaudo === TipoLaudo.RENOVABIO;
        },
        placeholders() {
            const placeholders = {
                hash_territorio: this.$t('mensagens.laudos.pesquisaInteligente.placeholder'),
                hash_car_territorio: this.$t('mensagens.laudos.pesquisaInteligente.placeholder1'),
                hash_car_territorio_produtor: this.$t('mensagens.laudos.pesquisaInteligente.placeholder2'),
                hash_car_territorio_emitente_credor: this.$t('mensagens.laudos.pesquisaInteligente.placeholder3'),
                hash_car: this.$t('mensagens.laudos.pesquisaInteligente.placeholder4')
            };

            const laudoPlaceholders = {
                [TipoLaudo.AGRICOLA]: placeholders.hash_territorio,
                [TipoLaudo.AVALIACAO_FUNDIARIA]: placeholders.hash_territorio,
                [TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA]: placeholders.hash_territorio,
                [TipoLaudo.CROQUI]: placeholders.hash_territorio,
                [TipoLaudo.DIAGNOSTICO_AGRICOLA]: placeholders.hash_territorio,
                [TipoLaudo.HISTORICO_AGRICOLA]: placeholders.hash_territorio,
                [TipoLaudo.SUPRESSAO_VEGETAL]: placeholders.hash_territorio,
                [TipoLaudo.AVALIACAO_SOCIOAMBIENTAL]: placeholders.hash_car_territorio,
                [TipoLaudo.BACEN_140]: placeholders.hash_car_territorio,
                [TipoLaudo.CARBONO]: placeholders.hash_car_territorio,
                [TipoLaudo.CONFORMIDADE]: placeholders.hash_car_territorio,
                [TipoLaudo.RELATORIO_TERRITORIAL]: placeholders.hash_car_territorio,
                [TipoLaudo.RENOVABIO]: placeholders.hash_car_territorio,
                [TipoLaudo.BACEN_FISCALIZACAO]: placeholders.hash_car_territorio_produtor,
                [TipoLaudo.BENFEITORIAS]: placeholders.hash_car_territorio_produtor,
                [TipoLaudo.TECNICO_AGRICOLA]: placeholders.hash_car_territorio_emitente_credor,
                [TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO]: placeholders.hash_car
            };

            return laudoPlaceholders[this.tipoLaudo] || '';
        }
    },
    created() {
        this.getUsuario();
        this.getSituacoes();
        this.getStatusAlerta();
        if (this.mostrarRenovabio) {
            this.getAnoCertificacao();
        }
        if (this.mostrarEmpresa && this.perfilAnalista) {
            this.remoteMethodEmpresa();
        }
        this.limparFiltros();
    },
    methods: {
        traduzirSituacao(situacao) {
            const normalizedSituacao = situacao
                .toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ /g, '-');
            return this.$t(
                `mensagens.relatorioCompartilhamentoDeDados.${normalizedSituacao}`
            );
        },
        getNome(nome, valor) {
            return nome !== undefined ? nome : valor;
        },
        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicar();
        },
        desmarcarFiltroPopover(filtro) {
            this.situacoesSelecionadas = this.situacoesSelecionadas.filter(
                s => s.codigo !== filtro.codigo
            );
            this.empresasSelecionadas = this.empresasSelecionadas.filter(
                e => e.id !== filtro.id
            );
            if (filtro.codigo === 'RENOVABIO') {
                this.filtros.elegivelRenovabio = '';
            }
            if (filtro.codigo === 'ANORENOVABIO') {
                this.filtros.anoRenovabio = null;
            }
            if (filtro.codigo === 'STATUS') {
                this.filtros.statusId = '';
                this.statusSelecionado = '';
            }
            if (filtro.codigo === 'DATACADASTRO') {
                this.filtros.dataCadastroInicio = '';
                this.filtros.dataCadastroFim = '';
            }
            if (filtro.codigo === 'DATAENTREGA') {
                this.filtros.dataFinalizacaoInicio = '';
                this.filtros.dataFinalizacaoFim = '';
            }
        },
        fecharLista() {
            setTimeout(() => {
                this.mostrarLista = false;
            }, 300);
        },
        tratarPesquisaInteligente(filtro) {
            if (filtro.length >= 3) {
                clearTimeout(this._timerId);
                this._timerId = setTimeout(() => {
                    this.aplicar();
                }, 600);
            }
        },
        getUsuario() {
            this.perfilAnalista = this.usuarioLogado.isAnalyst;
        },
        async getSituacoes() {
            const { data } = await LaudosService.getSituacoesPossiveis();
            this.situacoesPossiveis = data;
        },
        async getStatusAlerta() {
            const { data } = await LaudosService.getStatusPossiveis();
            this.statusPossiveis = data;
        },
        async getAnoCertificacao() {
            LaudosService.listarAnoRenovabio().then(response => {
                this.anos = response.data;
            }).catch(() => {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.ocorreuUmErroAoBuscarAnoCertificacaoRenovabio'
                    )
                });
            });
        },
        remoteMethodEmpresa() {
            setTimeout(() => {
                this.buscarEmpresas();
            }, 1000);
        },
        async buscarEmpresas() {
            const { data } = await UsuarioService.getGroups();
            this.listaEmpresas = data.sort((a, b) =>
                a.name.localeCompare(b.name)
            );
        },
        limparFiltros() {
            this.tags = [];
            this.empresasSelecionadas = [];
            this.situacoesSelecionadas = [];
            this.filtros = {
                territoriosIds: [],
                empresasIds: [],
                situacaoIds: [],
                dataCadastroInicio: '',
                dataCadastroFim: '',
                dataFinalizacaoInicio: '',
                dataFinalizacaoFim: '',
                filtro: '',
                tipoLaudoId: this.tipoLaudo,
                statusId: '',
                elegivelRenovabio: '',
                anoRenovabio: null
            };
            this.$emit('getFiltros', this.filtros);
        },
        setarTags() {
            let situacao = this.situacoesSelecionadas.map(s => s.id);
            let empresas = this.empresasSelecionadas.map(e => e.id);
            if (situacao.length > 0) {
                this.filtros.situacaoIds = situacao;
            } else {
                this.filtros.situacaoIds = [];
            }
            this.tags = [...this.situacoesSelecionadas];
            if (empresas.length > 0) {
                this.filtros.empresasIds = empresas;
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('EMPRESA-')
                );
                this.empresasSelecionadas.map(empresa => {
                    this.tags.push({
                        valor: empresa.name,
                        codigo: `EMPRESA-${empresa.name}`
                    });
                });
            }
            if (
                this.filtros.dataCadastroInicio &&
                this.filtros.dataCadastroFim
            ) {
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('DATACADASTRO')
                );
                this.tags.push({
                    valor: `Data de cadastro: de ${this.dataFormatada(
                        this.filtros.dataCadastroInicio
                    )} - ${this.dataFormatada(this.filtros.dataCadastroFim)}`,
                    codigo: `DATACADASTRO`
                });
            }
            if (
                this.filtros.dataFinalizacaoInicio &&
                this.filtros.dataFinalizacaoFim
            ) {
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('DATAENTREGA')
                );
                this.tags.push({
                    valor: `Data de entrega: de ${this.dataFormatada(
                        this.filtros.dataFinalizacaoInicio
                    )} - ${this.dataFormatada(
                        this.filtros.dataFinalizacaoFim
                    )}`,
                    codigo: `DATAENTREGA`
                });
            }
            if (this.statusSelecionado) {
                this.filtros.statusId = this.statusSelecionado.id;
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('STATUS')
                );
                this.tags.push({
                    valor: this.statusSelecionado.nome,
                    codigo: 'STATUS'
                });
            }
            if (this.filtros.elegivelRenovabio !== '') {
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('RENOVABIO')
                );

                this.tags.push({
                    valor: this.filtros.elegivelRenovabio ? this.$t('mensagens.laudos.elegivel') : this.$t('mensagens.laudos.inelegivel'),
                    codigo: 'RENOVABIO'
                });
            }
            if (this.filtros.anoRenovabio !== null) {
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('ANORENOVABIO')
                );

                this.tags.push({
                    valor: this.filtros.anoRenovabio,
                    codigo: 'ANORENOVABIO'
                });
            }
        },
        dataFormatada(data) {
            if (data) {
                const date = new Date(data);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            }
            return '';
        },
        aplicar() {
            this.setarTags();
            this.$emit('getFiltros', this.filtros);
        }
    }
};
</script>

<style scoped lang="scss">
#filtros {
    width: 100%;

    overflow: hidden;
    border-radius: 4px;

    label {
        margin-bottom: -5px;
    }

    .el-select {
        margin-top: -20px;
        width: 100%;
    }

    .el-date-picker {
        width: 40%;
    }

    .titulo {
        font-size: 14px;
        font-family: 'Roboto', 'sans serif';
    }

    .date {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .actions {
        margin-bottom: 0;

        .buttons {
            display: flex;
            justify-content: flex-end;
            margin-top: 15px;
        }
    }
}

.filtrar-laudo-container {
    display: flex;
    justify-content: space-between;
}

.filtrar-laudo-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.filtrar-laudo__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.filtrar-laudo-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-laudo-popover-header__text {
        color: var(--primary);
        font-weight: 600;
        font-size: 16px;
        line-height: 14px;
    }

    .filtrar-laudo-popover-header__link {
        color: var(--link);
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
        font-size: 16px;
        line-height: 14px;
    }
}

.filtrar-laudo-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;
}

.filtrar-laudo-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.filtrar-laudo-filtro-selecionado__tag {
    margin: 0px 5px 10px 5px;
}

.filtrar-laudo-filtro-selecionado__limpar {
    margin: 0px 5px 10px 5px;

    i {
        padding-left: 5px;
    }

    .el-icon-delete {
        cursor: pointer;
    }
}

.filtrar-laudo-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.el-popover-agricola {
    .el-divider--horizontal {
        margin: 12px 0;
    }
    .el-form {
        max-height: 785px;
    }
}

.el-popover-bacen-fiscalizacao {
    .el-divider--horizontal {
        margin: 12px 0;
    }
    .el-form {
        max-height: 785px;
    }
}

.el-popover-tecnico-agricola {
    .el-divider--horizontal {
        margin: 12px 0;
    }
    .el-form {
        max-height: 785px;
    }
}

.el-collapse-item__situacao--loading {
    min-height: 70px;
}

.el-collapse-item__date--loading {
    min-height: 35px;
}

.el-collapse-empresa--loading {
    min-height: 40px;
}

.checkbox-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    max-width: 600px;
}

.custom-collapse {
    width: 100%;
}
</style>
